import { z } from 'zod'

export const timezoneSchema = z.object({
  timezone: z.string(),
})
